import { find } from 'lodash';

import { Option } from '@components/Formik/MultiSelectFilter/types';
import { MemberFilter } from '@domui-presenters/web/components/DistrictMembersFilters/types';

import { ClubRosterFilter } from '@domui-domain/clubs';
import { ClubFilter } from '@domui-domain/districts';

export default (
  initialFilters: MemberFilter | ClubFilter | ClubRosterFilter,
  options?: Option[]
) => {
  const [searchName, searchValue] = window.location.search
    .substring(1)
    .split('=');
  const predefinedFilterValue = find(options, [
    'value',
    decodeURIComponent(searchValue),
  ]);

  return predefinedFilterValue
    ? {
        ...initialFilters,
        [searchName as string]: [predefinedFilterValue],
      }
    : initialFilters;
};
